import { Container } from '@mui/material'
import React, { useEffect, useState } from 'react'
// import shield from '@meprism/shared/src/assets/icons/shield-tick.svg'
// import { theme } from '../../config/Dashboardtheme'
// import ScannedSites from '../shared/atom/ScannedSites'
import { CorpStatusSelector, fetchCorpStats} from '../../redux/corporateService'
import MainHeader from '../shared/organism/MainHeader'
import { useAppDispatch } from '../../redux/storeExports'
import AllBusinessStats from './DashboardComponents/AllBusinessStats'
import TimePeriodStats from './DashboardComponents/TimePeriodStats'
import ActivityGraph from './DashboardComponents/ActivityGraph'

const DashboardView = () => {
  const dispatch = useAppDispatch();
  // const [isLoading, setIsLoading] = useState(true)
  const [dashboardLoading, setDashboardLoading] = useState(true)
  // const accountType = SelectAccountType()
  // const companySize = SelectCompanySize()
  // const isExecutiveAdmin = accountType === 'executive'
  // const UserStatus = UserStatusSelector()
  const CorpStatus = CorpStatusSelector()
  // const corporateCode = SelectCorporateCode()
  useEffect(()=>{
    const fetchCorporateStats = async () => {
      try {
        setDashboardLoading(true)
        if (!CorpStatus) {
          await dispatch(fetchCorpStats())
        }
      } catch (e) {
        console.log('error fetching users: ', e)
      } finally {
        setDashboardLoading(false)
      }
    }
    fetchCorporateStats()
  }, [dispatch, CorpStatus])

  // useEffect(()=>{
  //   const fetchEmployeeUsers = async()=>{
  //   try{
  //     setIsLoading(true)
  //     await dispatch(fetchUsersStats(isExecutiveAdmin))
  //   if(isExecutiveAdmin){
  //     const code = await dispatch(fetchCode()).unwrap()
  //     await dispatch(FetchExecutiveUsers(code))
  //   }
  //   else{
  //     await store.dispatch(fetchUsers())
  //   }
  // }catch(e){
  //     console.log('error fetching users: ',e)
  //   }finally{
  //     setIsLoading(false)
  //   }
  // }
  //   fetchEmployeeUsers()
  // },[dispatch, isExecutiveAdmin])
  // const removing =
  //   UserStatus.total_employees_brokers_in_new +
  //   UserStatus.total_employees_brokers_in_removing
  // const removed = UserStatus.total_employees_brokers_in_removed
  // const participating = UserStatus.total_participating_employees
  // const pending = UserStatus.total_pending_employees
  // const removaldata = [
  //   { name: 'Removing', value: removing },
  //   { name: 'Removed', value: removed },
  // ]
  // const invitedata = [
  //   { name: isExecutiveAdmin? 'Limit':'Pending', value: isExecutiveAdmin? companySize:pending },
  //   { name: isExecutiveAdmin?'Added Employees':'Participating', value: participating },
  // ]

  // const colors = ['#C67EFF', '#426BF0']
  // const colors2 = ['#E2B93B', '#27AE60']
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
  <Container
    maxWidth={false}
    sx={{
      maxWidth: '1072px',
      gap: '20px',
      opacity: 1,
      px: { xs: '8px', sm: '8px', md: '8px', lg: 0, xl: 0}
    }}
  >
    <MainHeader title="Privacy Dashboard" />
    {dashboardLoading ? (
      <>
        <AllBusinessStats loading />
        <TimePeriodStats/>
      </>
    ) : (<>
      <AllBusinessStats
        found={CorpStatus?.all_time?.found || 0}
        removed={CorpStatus?.all_time?.removed || 0}
        optOutSubmitted={CorpStatus?.all_time?.optout_submitted || 0}
      />

    <TimePeriodStats
      last_7_days={{
        records_in_progress: CorpStatus?.last_7_days?.records_in_progress || 0,
        brokers_monitored: CorpStatus?.last_7_days?.brokers_monitored || 0,
        clean_scans: CorpStatus?.last_7_days?.clean_scans || 0,
      }}
      last_30_days={{
        records_in_progress: CorpStatus?.last_30_days?.records_in_progress || 0,
        brokers_monitored: CorpStatus?.last_30_days?.brokers_monitored || 0,
        clean_scans: CorpStatus?.last_30_days?.clean_scans || 0,
      }}
    />
    </>)}
    <ActivityGraph
      labels={CorpStatus?.chart_data?.labels || []}
      found={CorpStatus?.chart_data?.found || []}
      removed={CorpStatus?.chart_data?.removed || []}
      inProgress={CorpStatus?.chart_data?.optout_in_progress || []}
    />
    
  </Container>
  )
}

export default DashboardView
